import type { Meta, StoryFn } from '@storybook/react';
import type { LabelProps } from './Label';

import { Label } from './Label';

const codeString = `
// Has all LabelHTMLAttributes props available except "className" and "style" 
 <Label htmlFor={htmlFor}>{children}</Label>
`;

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/Label',
  component: Label,
  argTypes: {
    htmlFor: {
      control: 'text',
    },
    children: {
      control: 'text',
    },
  },
  parameters: {
    inspectComponent: Label,
    codeString: codeString,
  },
} as Meta<LabelProps>;

const Template: StoryFn<LabelProps> = (args) => <Label {...args} />;

const defaultArgs: Partial<LabelProps> = {
  children: 'Lorem Ipsum',
  htmlFor: 'bd79f7ec',
};

export const LabelExample = Template.bind({});
LabelExample.args = {
  ...defaultArgs,
};

export const WithNoFontWeight = Template.bind({});
WithNoFontWeight.args = {
  ...defaultArgs,
  noFontWeight: true,
};
